import React, { useState } from 'react'

import { useLocation } from 'react-router-dom'
import { isEmpty, isNull } from 'lodash'
import { Button } from '@material-ui/core'
import { HelpCircle as HelpCircleIcon } from 'react-feather'

import {
  Container,
  ContentHeader,
  DialogLogs,
  LoadingFeedback,
  MenuButton,
  Page,
} from 'components'
import { ShowForm } from './components'

import ThirdPartyManagementStepperProvider from 'providers/ThirdPartyManagementStepperProvider'

import useFetch from 'hooks/useFetch'
import useConvertToFile from 'hooks/useConvertToFile'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'

const ThirdPartyManagementMySuppliersShow = ({ match }) => {
  const { companySupplierId } = match.params
  const location = useLocation()

  const [openTour, setOpenTour] = useState(false)
  const [openLogDialog, setOpenLogDialog] = useState(false)
  const [activeStep, setActiveStep] = useState(location.state?.initialStep ?? 0)

  const { response } = useFetch(service.dponet.suppliers.get, {
    companySupplierId,
  })

  const { response: responseLogs, isLoading: isLoadingLogs } = useFetch(
    service.dponet.suppliers.logs,
    {
      companySupplierId,
    },
    [openLogDialog],
    openLogDialog,
  )

  const logs = helpers.logs.changeLogs(responseLogs?.data?.dponetAudits || [])
  const companySupplier = response?.data?.companySupplier || {}
  const isPreAvaliation = companySupplier?.preAvaliation

  const { fileList, loading } = useConvertToFile(
    companySupplier?.companySupplierDetail?.attachments,
  )

  return (
    <Page
      title={`Gestão de Fornecedores - Visualizar ${
        isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'
      }`}
    >
      <LoadingFeedback open={loading} />
      <Container maxWidth={false}>
        <ContentHeader
          title={`Visualizar ${
            isPreAvaliation ? 'Pré-Avaliado' : 'Fornecedor'
          }`}
          breakLine={false}
          preserveSearch
        >
          <Button
            id={
              isPreAvaliation
                ? constants.tours.thirdPartyManagements.STEPS.PRE_AVALIATION
                    .SHOW.EVALUATION[1]
                : constants.tours.thirdPartyManagements.STEPS.SHOW.EVALUATION[1]
            }
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={() => setOpenTour(true)}
          >
            Tutorial
          </Button>

          <MenuButton>
            <Button
              color="secondary"
              onClick={() => setOpenLogDialog(true)}
              fullWidth
            >
              Histórico
            </Button>
          </MenuButton>
        </ContentHeader>

        {(fileList ||
          isNull(companySupplier?.companySupplierDetail?.attachments)) && (
          <ThirdPartyManagementStepperProvider
            isShow
            isPreAvaliation={isPreAvaliation}
            companySupplier={companySupplier}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
          >
            <ShowForm
              fileList={fileList}
              openTour={openTour}
              setOpenTour={setOpenTour}
            />
          </ThirdPartyManagementStepperProvider>
        )}
      </Container>

      <LoadingFeedback open={isLoadingLogs} />

      <DialogLogs
        logs={isEmpty(logs) ? undefined : logs}
        open={openLogDialog}
        setOpen={setOpenLogDialog}
        showRegisterSession={false}
      />
    </Page>
  )
}

export default ThirdPartyManagementMySuppliersShow
